import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'I Need A Social Worker';
const DEFAULT_DESC = 'Verified social work jobs, licensed clinical supervisors, and a national community resource directory — all in one trusted place.';

/**
 * Per-page SEO: title, meta description, canonical, and Open Graph / Twitter cards.
 * Pass a `path` (e.g. "/jobs/123") to build the canonical + og:url from the live origin.
 */
export const Seo = ({ title, exactTitle, description, path, image, type = 'website', noindex = false }) => {
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://ineedasocialworker.com';
  const url = path ? `${origin}${path}` : (typeof window !== 'undefined' ? window.location.href.split('?')[0] : origin);
  const fullTitle = exactTitle || (title ? `${title} | ${SITE_NAME}` : SITE_NAME);
  const desc = (description || DEFAULT_DESC).slice(0, 300);
  const ogImage = image || `${origin}/og-default.png`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default Seo;
